import { EyeOffIcon, EyeIcon } from "@heroicons/react/outline";

import { useGridContext } from "../hooks/useEvaluateGridContext";

export const ColumnVisibilitySection = () => {
  const { hideDatasetColumns, showAllColumns } = useGridContext();

  return (
    <div className="border-t border-gray-200 pt-1.5">
      <h4 className="mb-1.5 text-xs font-medium uppercase tracking-wide text-gray-600">Columns</h4>
      <div className="space-y-0.5">
        <button
          className="flex w-full items-center gap-2.5 rounded-md px-2.5 py-1.5 text-left text-sm text-gray-700 transition-colors hover:bg-gray-100"
          onClick={hideDatasetColumns}
        >
          <EyeOffIcon className="h-4 w-4 flex-shrink-0" />
          <div className="min-w-0">
            <div className="font-medium">Hide dataset columns</div>
            <div className="text-xs text-gray-500">Hides dataset columns</div>
          </div>
        </button>
        <button
          className="flex w-full items-center gap-2.5 rounded-md px-2.5 py-1.5 text-left text-sm text-gray-700 transition-colors hover:bg-gray-100"
          onClick={showAllColumns}
        >
          <EyeIcon className="h-4 w-4 flex-shrink-0" />
          <div className="min-w-0">
            <div className="font-medium">Show all columns</div>
            <div className="text-xs text-gray-500">Shows all columns</div>
          </div>
        </button>
      </div>
    </div>
  );
};
